/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2018 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 */

import React from "react";
import {Button, Notification} from "@scuf/common";
import {FormattedHTMLMessage} from "react-intl";
import {Routes} from "../../utils/Routes";
import {withRouter} from "react-router";

class AssetExistNotification extends React.Component {

    render() {
        const {existingAsset, history} = this.props

        if(existingAsset && existingAsset.asset.status === 'disabled' && existingAsset.readAccess === true) {
            return (
                <Notification hasIcon={true} severity="important">
                    <FormattedHTMLMessage id="admin.asset.detail.asset.exists.has.access.1"
                                          values={{'assetName': existingAsset.asset.name}}/>
                    <Button type="link" onClick={() => {
                        history.push(Routes.ASSETS_ADMIN + "/" + existingAsset.asset.id);
                        history.go();
                    }}>
                        <FormattedHTMLMessage id="admin.asset.detail.asset.exists.has.access.2"/>
                    </Button>
                    <FormattedHTMLMessage id="admin.asset.detail.asset.exists.has.access.3"/>
                </Notification>
            )
        } else if (existingAsset && existingAsset.asset.status === 'disabled') {
            return (
                <Notification hasIcon={true} severity="important">
                    <FormattedHTMLMessage id="admin.asset.detail.asset.exists.has.not.access"
                                          values={{'assetName': existingAsset.asset.name}}/>
                </Notification>
            )
        } else {
            return null;
        }
    }
}

export default withRouter(AssetExistNotification)
